"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openAccountNameModal = openAccountNameModal;
exports.stageDefaultAccountName = stageDefaultAccountName;
exports.default = void 0;

var _empty = require("rxjs/observable/empty");

var _of = require("rxjs/observable/of");

var _take = require("rxjs/operators/take");

var _map = require("rxjs/operators/map");

var _mergeMap = require("rxjs/operators/mergeMap");

var _reduxObservable = require("redux-observable");

var _actions = require("settings-ui-sdk/Hubs/actions");

var _selectors = require("../selectors");

var _AccountDefaultsActions = require("../actions/AccountDefaultsActions");

var _selectors2 = require("settings-ui-sdk/Hubs/selectors");

var _constants = require("settings-ui-sdk/Hubs/constants");

var _Modals = _interopRequireDefault(require("../constants/Modals"));

function openAccountNameModal($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.FetchHubActionTypes.SUCCESS).pipe((0, _take.take)(1), (0, _mergeMap.mergeMap)(function () {
    if ((0, _selectors.getCanEdit)(getState()) && !(0, _selectors2.getHub)(getState()).get(_constants.ACCOUNT_NAME)) {
      return (0, _of.of)((0, _AccountDefaultsActions.openModal)(_Modals.default.SET_ACCOUNT_NAME), (0, _actions.loadSuggestedAccountName)());
    }

    return (0, _empty.empty)();
  }));
}

function stageDefaultAccountName($action, _ref2) {
  var getState = _ref2.getState;
  return $action.ofType(_actions.FetchSuggestedAccountNameActionTypes.SUCCESS).pipe((0, _take.take)(1), (0, _map.map)(function () {
    return (0, _actions.stageHubChange)(_constants.ACCOUNT_NAME, (0, _selectors2.getSuggestedAccountName)(getState()));
  }));
}

var _default = (0, _reduxObservable.combineEpics)(openAccountNameModal, stageDefaultAccountName);

exports.default = _default;